

import {Action} from '@ngrx/store';

export const GET_FUNKPROTOKOLL_FALL_BILD_SCALED = '[VeranstaltungenModul] GetFunkprotokollFallBildScaled laden';
export const GET_FUNKPROTOKOLL_FALL_BILD_SCALED_AUSFUEHREN = '[VeranstaltungenModul] GetFunkprotokollFallBildScaled ausführen';
export const GET_FUNKPROTOKOLL_FALL_BILD_SCALED_ERFOLGREICH = '[VeranstaltungenModul] GetFunkprotokollFallBildScaled laden erfolgreich';
export const GET_FUNKPROTOKOLL_FALL_BILD_SCALED_FEHLER = '[VeranstaltungenModul] GetFunkprotokollFallBildScaled Ladefehler';
export const GET_FUNKPROTOKOLL_FALL_BILD_SCALED_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] GetFunkprotokollFallBildScaled nicht ausgeführt (evtl. Offline)';


export class GetFunkprotokollFallBildScaledAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_FALL_BILD_SCALED;
        constructor( public veranstaltung_id:string ,  public fall_id:string ,  public bild_id:string ,  public width:number ,  public height:number , public optPayload: any = null) {}
    }
export class GetFunkprotokollFallBildScaledAusfuehrenAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_FALL_BILD_SCALED_AUSFUEHREN;
        constructor( public veranstaltung_id:string ,  public fall_id:string ,  public bild_id:string ,  public width:number ,  public height:number , public optPayload: any = null) {}
    }
export class GetFunkprotokollFallBildScaledErfolgreichAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_FALL_BILD_SCALED_ERFOLGREICH;
        constructor(public payload: string,  public veranstaltung_id:string ,  public fall_id:string ,  public bild_id:string ,  public width:number ,  public height:number , public optPayload: any = null) {}
    }
export class GetFunkprotokollFallBildScaledFehlerAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_FALL_BILD_SCALED_FEHLER;
        constructor(public payload: any,  public veranstaltung_id:string ,  public fall_id:string ,  public bild_id:string ,  public width:number ,  public height:number , public optPayload: any = null) {}
    }
export class GetFunkprotokollFallBildScaledNichtAusgefuehrtAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_FALL_BILD_SCALED_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenQueryFunkprotokollFallBildScaledActions =
    GetFunkprotokollFallBildScaledAction
    | GetFunkprotokollFallBildScaledAusfuehrenAction
    | GetFunkprotokollFallBildScaledErfolgreichAction
    | GetFunkprotokollFallBildScaledFehlerAction
    | GetFunkprotokollFallBildScaledNichtAusgefuehrtAction
    ;
